import {TableToolbar, TableToolbarContent, TableBatchActions, DismissibleTag, Button} from '@carbon/react';
import {SaveRosterButton} from './save-roster-button';

export interface ProviderTableToolbarProps {
    filters: any[];
    selection: string[];
    deselection: string[];
    revisionId: number;
    toolbarProps: any;
    batchActionProps: any;
    onFilterRemove: (filter: any) => void;
    onCancelSelection: () => void;
    onSaveRoster: () => Promise<void>;
    setSaveRosterModalOpen: (open: boolean) => void;
    unselectedCount: number;
    onSelectAll: () => void;
    onUnselectAll: () => void;
    unselectAllCount: number;
}

export function ProviderTableToolbar({
    filters,
    selection,
    deselection,
    revisionId,
    toolbarProps,
    batchActionProps,
    onFilterRemove,
    onCancelSelection,
    onSaveRoster,
    setSaveRosterModalOpen,
    unselectedCount,
    onSelectAll,
    onUnselectAll,
    unselectAllCount
}: ProviderTableToolbarProps) {
    const getBatchActionText = (id: string) => {
        if (id === 'carbon.table.batch.cancel') return 'Cancel';
        return `${selection.length ? `${selection.length} provider${selection.length > 1 ? 's' : ''} to add${deselection.length ? ', ' : ''}` : ''}${deselection.length ? `${deselection.length} provider${deselection.length > 1 ? 's' : ''} to remove` : ''}`;
    };

    const hasSelectionButtons = unselectedCount > 0 || unselectAllCount > 0;
    const hasToolbar = filters.length > 0 || !!selection.length || !!deselection.length;

    return (
        <div>
            {hasSelectionButtons && (
                <div className='flex items-center px-4 py-1 bg-white border-b border-gray-200'>
                    {unselectedCount > 0 && (
                        <Button kind='ghost' size='sm' onClick={onSelectAll}>
                            Select All ({unselectedCount})
                        </Button>
                    )}
                    {unselectAllCount > 0 && (
                        <Button kind='ghost' size='sm' onClick={onUnselectAll}>
                            Unselect All ({unselectAllCount})
                        </Button>
                    )}
                </div>
            )}
            {hasToolbar && (
                <TableToolbar {...toolbarProps} size='sm' aria-label="data table toolbar">
                    {filters.length > 0 && (
                        <TableToolbarContent>
                            {filters.map((filter: any, i: number) =>
                                <DismissibleTag
                                    key={i}
                                    onClose={() => onFilterRemove(filter)}
                                    text={`${filter.variable.label} ${filter.test} ${filter.value}`}
                                />
                            )}
                        </TableToolbarContent>
                    )}
                    <TableBatchActions
                        {...batchActionProps}
                        shouldShowBatchActions={!!selection.length || !!deselection.length}
                        translateWithId={getBatchActionText}
                        totalSelected={selection.length + deselection.length}
                        onCancel={onCancelSelection}
                    >
                        <SaveRosterButton
                            revisionId={revisionId}
                            setModalOpen={setSaveRosterModalOpen}
                            onUpdate={onSaveRoster}
                        />
                    </TableBatchActions>
                </TableToolbar>
            )}
        </div>
    );
}
